<template>
  <v-btn
    color="white"
    :aria-label="buttonText"
    @click="navigateToRedemptionHistory"
  >
    <template #default>
      <span class="d-flex flex-column">
        <v-icon
          :large="$vuetify.breakpoint.smAndDown"
          :x-large="$vuetify.breakpoint.mdAndUp"
          color="grey darken-2"
        >
          mdi-credit-card-clock-outline
        </v-icon>
        <span
          class="text-capitalize subtitle-1 d-none d-md-block"
          v-text="buttonText"
        />
      </span>
    </template>
  </v-btn>
</template>
<script>
import { REDEMPTION_HISTORY_ROUTE } from '@/router/routes/route-names'
import * as orderHistoryEvents from '@/plugins/segment/SegmentConstants'

export default {
  name: 'RedemptionHistoryBtn',
  props: {
    mobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    redemptionHistoryRoute () {
      return { name: REDEMPTION_HISTORY_ROUTE }
    },
    buttonText () {
      return this.$t('redemption-history-button-text')
    }
  },
  methods: {
    navigateToRedemptionHistory () {
      this.$segment.track(orderHistoryEvents.ORDER_HISTORY_BUTTON_CLICKED)
      this.$router.push(this.redemptionHistoryRoute)
    }
  }
}
</script>
